import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { fmtPoints, addDays } from "../data/mock";

const cabinLabel = { economy: "Economy", premium: "Premium", business: "Business", first: "First" };

// "Most booked this week" — powered by real Book-on-airline click data
export default function TrendingRoutes() {
  const [routes, setRoutes] = useState(null);
  useEffect(() => { api.trending(7).then((d) => setRoutes(d.routes)).catch(() => setRoutes([])); }, []);
  if (!routes || routes.length === 0) return null;
  const date = addDays(new Date().toISOString().slice(0, 10), 14);
  return (
    <section className="mx-auto max-w-7xl px-5 pb-4" data-testid="trending-routes">
      <div className="flex items-center gap-2 text-orange-600"><Flame className="h-4 w-4" /><span className="text-xs font-bold uppercase tracking-wide">Most booked this week</span></div>
      <div className="mt-3 flex gap-3 overflow-x-auto pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {routes.map((r, i) => (
          <Link key={r.route} to={`/search?from=${r.origin.code}&to=${r.destination.code}&date=${date}&flex=3`} data-testid="trending-route" className="group flex min-w-[220px] shrink-0 items-center justify-between gap-3 rounded-2xl border border-slate-200 bg-white px-4 py-3 transition-colors hover:border-orange-300">
            <span className="min-w-0">
              <span className="block text-sm font-extrabold text-slate-900">{r.origin.code} → {r.destination.code}<span className="ml-1.5 text-[10px] font-bold text-orange-600">#{i + 1}</span></span>
              <span className="block truncate text-xs text-slate-500">{r.origin.city} → {r.destination.city}</span>
              <span className="block text-xs text-slate-600">from <b className="text-slate-900">{fmtPoints(r.fromPoints)}</b> pts{r.cabin ? ` · ${cabinLabel[r.cabin] || r.cabin}` : ""}</span>
            </span>
            <ArrowRight className="h-4 w-4 shrink-0 text-slate-300 transition-transform group-hover:translate-x-0.5 group-hover:text-orange-500" />
          </Link>
        ))}
      </div>
    </section>
  );
}
